import {$, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import Auditoria from '@/model/resource/Auditoria'
import Endereco from '@/model/resource/Endereco'
import StatusNotificacaoAuditoria from '@/model/resource/StatusNotificacaoAuditoria'
import AuditoriaValidationSchema from '@/schema/AuditValidation.schema'

export default class AuditValidation extends Resource {

    get $id() {
        return this.idCargaFk
    }

    set $id(val: ID) {
        this.idCargaFk = val
    }

    get $schema() {
        return AuditoriaValidationSchema(this)
    }

    idCargaFk: ID = 0
    nroNotaFiscal: string | null = null
    nroCte: string | null = null
    danfe: string | null = null
    entregador: string | null = null
    placaVeiculo: string | null = null
    transportador: string | null = null
    observacaoAuditoria: string | null = null

    @ResponseSerialize(Endereco)
    enderecoEntrega: Endereco | null = null

    dataHoraCriacao: Date | null = null
    dataHoraBaixa: Date | null = null
    dataHoraEntrega: Date | null = null

    @ResponseSerialize(Auditoria)
    auditoria: Auditoria | null = null

    @ResponseSerialize(StatusNotificacaoAuditoria)
    statusNotificacaoAuditoria: StatusNotificacaoAuditoria  | null = null

    get auditoriaStatusTagClass() {
        if (this.auditoria) {
            if (this.auditoria.conforme) {
                return 'green-dark'
            } else {
                return 'danger'
            }
        }
        return 'default'
    }

    get auditoriaStatus() {
        if (this.auditoria) {
            if (this.auditoria.conforme) {
                return $.t('classes.Carga.columns.conform')
            } else {
                return $.t('classes.Carga.columns.disapprove')
            }
        }

        return ''
    }

    readonly $name: string = 'AuditValidation'
    readonly $endpoint: string = '/user/carga/auditoria-validacao'
}
